import { Product } from './product/product'

//一つのカテゴリー
export class ProductCategory{
    id : number = 0;
    name : string = ""; //カテゴリー名
    imagePath : string = ""; //カテゴリーの画像(意味不明)
    region : string = ""; //カテゴリーの国コード(意味不明)
    productCategorySortNum : number = 0;

    productList : Product[] = [ new Product() ]; //商品の配列

    // idb処理用のシーケンス番号
    seq: number = 0;
}
